<div class="print-container">
    <h1 class="page-label">Portal Validation - Enter Order Info</h1>
    <h4 class="page-label">Selected Portal: {{ portal?.name }}</h4>
</div>

<div class="print-container">
    <div>
        <div class="row">
            <label class="col-sm-5 input-label" for="dopv-orderName">Order Name:</label>
            <input id="dopv-orderName" [(ngModel)]="orderName" class="col-sm-7 form-control" type="text" [readonly]="isUiDisabled" [disabled]="isUiDisabled" (keyup.enter)="onGetInfoClicked()" >
        </div>
    </div>
</div>

<div class="print-container">
    <div class="row">
        <button (click)="onGetInfoClicked()" class="submit btn btn-primary col-sm-8" [disabled]="isUiDisabled">Get Info</button>
    </div>
</div>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog
    >
</ef-simple-indefinite-progress-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>